import styled from 'styled-components'

export const ItemContainer = styled.div`
  display: flex;
  background-color: ${props => props.backgroundColor};
  border-radius: ${props => props.theme.primitives.radius.radius2};
  padding: ${props => props.theme.spacing.sp16};
`

export const IdentifierContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: ${props => props.theme.spacing.sp16};
  margin-right: ${props => props.theme.spacing.sp16};
  border-right: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};
  min-width: 50px;
`

export const InfoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

export const NameContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
  align-items: center;
`
